export interface IAppDefaults {
  Homography: {
    lprStandardPoints: number[];
    mapHomographyBoundingPoints: number[][];
    scrollSensitivity: number;
  };
}

export interface IConfig {
  API: string;
  APIv2: string;
  MESSENGER_API: string;
  INSTANCE: string;
  DEFAULT_REJECTION_REASON_TAG_ID: number;
  DEFAULT_REJECTION_REASON_TAG_ID_EU: number;
  GoogleApiKey: string;
  MapboxApiKey: string;
  AppClientID: string;
  CognitoAuthUrl: string;
  UserPoolID: string;
  AWSRegion: string;
  StageName: string;
  AppDefaults: IAppDefaults;
}

export const Config: IConfig = {
  API: process.env.REACT_APP_API_URL || 'http://localhost:3000/api/v1',
  APIv2: process.env.REACT_APP_APIv2_URL || 'http://localhost:3000/api/v2',
  MESSENGER_API: process.env.REACT_APP_MESSENGER_API_URL || 'http://localhost:3000/api/v1',
  INSTANCE: process.env.REACT_APP_INSTANCE || 'localhost',
  StageName: process.env.REACT_APP_HAYDEN_ENV || 'beta',
  DEFAULT_REJECTION_REASON_TAG_ID: 100,
  DEFAULT_REJECTION_REASON_TAG_ID_EU: 1,
  MapboxApiKey: '',
  GoogleApiKey: '',
  AppClientID: '',
  CognitoAuthUrl: '',
  UserPoolID: '',
  AWSRegion: '',
  AppDefaults: {
    Homography: {
      lprStandardPoints: [],
      mapHomographyBoundingPoints: [
        [5, 10],
        [-5, 10],
        [-5, 40],
        [5, 40],
      ],
      scrollSensitivity: 0.001,
    },
  },
};
